import contentful, {
  flattenEntryResponse,
  flattenEntryResponseSingle,
} from '@aletheia/common/lib/contentful'

import { IPost } from '../types/generated'

/**
 * Fetch a single Post from Contentful
 *
 * @param {string} slug The slug of this Post
 */
export const fetchPost = async (slug: string): Promise<IPost | undefined> => {
  return flattenEntryResponseSingle(
    await contentful.getEntries({
      content_type: 'post',
      'fields.slug': slug,
      include: 5,
    }),
  ) as IPost | undefined
}

/**
 * Fetch all Posts from Contentful
 *
 * @param {object} query Options to pass to contentful.getEntries()
 */
export const fetchPosts = async (
  query?: Record<string, unknown>,
): Promise<IPost[]> => {
  return flattenEntryResponse(
    await contentful.getEntries({
      include: 5,
      order: '-fields.datePublished',
      ...query,
      content_type: 'post',
    }),
  ) as IPost[]
}
